import { ModelCommon, UserAttributeDef, UserAttributeDefs, toDatePickerFormat, ValidModelType } from '@iotv/datamodel-core';
import { isValidBusinessObject, MapLike, PathDirection } from '@iotv/iotv-v3-types';

const typeName = 'IrrigatorDownlinks';

export type IrrigatorDownlinksProps = {
  payload?: string;
  time?: number;
};

export class IrrigatorDownlinks extends ModelCommon {
  constructor(ob: any) {
    super(ob.type || typeName, ob);
  }

  payload?: string;
  time?: number;

  getUserAttributes(): UserAttributeDefs {
    return {
      ...super.getUserAttributes(),
      payload: { type: 'String', editable: true, label: 'payload', name: 'payload', description: 'The raw payload ' },
      time: { type: 'Number', editable: true, label: 'time', name: 'time', description: 'The time of the message (UTC)' },
    };
  };
}
